module.exports = __webpack_public_path__ + "site/img/22.cfd7d244.jpg";